import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { useMemo, useState } from 'react';

import { Button } from '@/components/Button';
import { useDraftTimelogStore } from '@/features/draftTimelogs';
import { PublishDraftsConfirmDialog } from '@/features/draftTimelogs/ui/PublishDraftsConfirmDialog';

import { useTimeLogStore } from '../../model';

/** Кнопка публикации всех черновиков за неделю относительно `currentDate` (для переиспользования вне основного хедера). */
const PublishDraftsButton = observer(() => {
  const { drafts, publishBulk } = useDraftTimelogStore();
  const { currentDate } = useTimeLogStore();
  const [openDialog, setOpenDialog] = useState(false);

  const weekStart = currentDate.startOf('week').startOf('day');
  const weekEnd = weekStart.plus({ days: 6 }).endOf('day');

  const weekDrafts = useMemo(() => {
    return drafts.filter((draft) => {
      const draftDate = DateTime.fromISO(draft.start);

      return draftDate >= weekStart && draftDate <= weekEnd;
    });
  }, [drafts, weekStart, weekEnd]);

  const weekDraftsWithoutTask = useMemo(
    () => weekDrafts.filter((draft) => !draft.taskKey).length,
    [weekDrafts],
  );

  const publishWeekDrafts = async () => {
    await publishBulk(weekStart.toISO()!, weekEnd.toISO()!);
  };

  if (weekDrafts.length === 0) return null;

  return (
    <>
      <Button
        variant="outlined"
        onClick={() => {
          if (weekDraftsWithoutTask > 0) {
            setOpenDialog(true);
          } else {
            void publishWeekDrafts();
          }
        }}
        sx={{ height: '32px', fontSize: '13px' }}
      >
        Опубликовать все черновики
      </Button>
      <PublishDraftsConfirmDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        draftsWithoutTaskCount={weekDraftsWithoutTask}
        onConfirmPublish={publishWeekDrafts}
      />
    </>
  );
});

export default PublishDraftsButton;
